import { supabase } from '../supabaseClient';

async function getAllCounts(year, usersarray, projectarray,statusarray,eventarray,tokenarray,wingarray,endDate,startDate) {
    let { data, error } = await supabase.rpc('dashboardanalytics', { year: year, usersarray: usersarray, projectarray: projectarray ? projectarray : [],statusarray : statusarray ? statusarray : [],eventarray : eventarray ? eventarray : [],tokenarray : tokenarray ? tokenarray : [],wingarray: wingarray ? wingarray : [],enddate: endDate ? endDate : 0, startdate : startDate ? startDate : 0 }).select('*')
    if (data) return data
    else throw error
}

async function getTopProjects(usersarray) {
    let { data, error } = await supabase.rpc('topprojects', { usersarray }).select('*')
    if (data) return data
    else throw error
}

async function getTopSalesByProject(projectId) {
    let { data, error } = await supabase.rpc('topsalesbyproject', { projectid: projectId }).select('*')
    if (data) return data
    else throw error
}

async function getTopCpByProject(projectId) {
    let { data, error } = await supabase.rpc('topcpbyproject', { projectid: projectId }).select('*')
    if (data) return data
    else throw error
}

async function getTopSales(usersarray, projectarray) {
    let { data, error } = await supabase.rpc('topsales', { usersarray: usersarray, projectarray: projectarray }).select('*')
    if (data) return data
    else throw error
}

async function getUniqueUnitTypes(projectId) {
    let { data, error } = await supabase.rpc('getuniqueunittypes', { pid: projectId }).select('*')
    if (data) return data
    else throw error
}

async function projectAnalytics(projectId) {
    let { data, error } = await supabase.rpc('projectanalytics', { projectid: projectId }).select('*')
    if (data) return data
    else throw error
}

async function getCountsByYearForProject(year, unitType, projectId) {
    let { data, error } = await supabase.rpc('getMonthlyDataForAnalyticsOfProject', { year: year, unittype: unitType, projectid: projectId }).select('*')
    if (data) return data
    else throw error
}

async function getProjects() {
    let { data, error } = await supabase.from('Projects').select('*').eq('isVJ', true)
    if (data) return data
    else throw error
}

async function getCp() {
    let { data, error } = await supabase.from('CP').select('*')
    if (data) return data
    else throw error
}

async function getTopFosByCp(cpId) {
    let { data, error } = await supabase.rpc('topfosbycp', { cpid: cpId })
    if (data) return data
    else throw error
}

async function cpAnalytics(cpId) {
    let { data, error } = await supabase.rpc('cpanalytics', { cpid: cpId })
    if (data) return data
    else throw error
}

async function getdataforcpdoughnut(year, cpId) {
    let { data, error } = await supabase.rpc('getdataforcpdoughnut', { year: year, cpid: cpId })
    if (data) return data
    else throw error
}

async function getTokenDataBySalesTeam(usersarray, projectarray) {
    let { data, error } = await supabase.rpc('salesteamanalysis', { usersarray: usersarray, projectarray: projectarray })
    if (data) return data
    else throw error
}

async function getUnitAnalysis(projectarray) {
    let { data, error } = await supabase.rpc('unitanalysis', { projectarray: projectarray })
    if (data) return data
    else throw error
}

async function getTokenWiseUnitsSold(projectarray) {
    let { data, error } = await supabase.rpc('tokenwiseunitssold', { projectarray: projectarray })
    if (data) return data
    else throw error
}

async function getTopSalesInEvent(projectarray) {
    let { data, error } = await supabase.rpc('topsalesinevent', { projectarray: projectarray })
    if (data) return data
    else throw error
}

async function getTopSalesInSustenance(projectarray) {
  let { data, error } = await supabase.rpc('topsalesinsustenance', {
    projectarray: projectarray,
  });
  if (data) return data;
  else throw error;
}

async function FetchTeamWiseUserFromServer(
  from,
  to,
  teamIds,
  projectId,
  userId,
  selectedDate
) {
  let query = supabase
    .from('AllotmentPayment')
    .select(
      'created_at , unitCost , userId , kycFormFilled , status , allotmentPaymentId ,leadId(leadId , leadType , cpId , personId(name , personId) , userId(name , userId)) , unitId(chargeableArea , unitNo , inventoryStatusId(status) , leadId , totalCost, wingId(wingName , wingId) , projectId(projectId , projectName) , inventoryTypeId(inventoryTypeId , type))'
    );

  if (projectId?.length > 0) {
    query = query.in('unitId.projectId.projectId', projectId);
  }

  if (userId === null || userId === '' || userId === undefined) {
    query = query.in('leadId.userId', teamIds);
  } else {
    query = query.in('leadId.userId', [userId]);
  }

  if (
    selectedDate?.[0]?.value !== '0' &&
    selectedDate?.[1]?.value !== '0' &&
    selectedDate !== null &&
    selectedDate !== undefined
  ) {
    query = query
      .lte('created_at', selectedDate?.[1]?.value)
      .gte('created_at', selectedDate?.[0]?.value);
  }

  const { data, error, count } = await query;
  if (data) return { data, count };
  else throw error;
}

async function FetchInventoryFromServer(
  from,
  to,
  teamIds,
  projectId,
  userId,
  selectedDate
) {
  let query = supabase
    .from('Inventory')
    .select(
      'created_at ,projectId , unitNo , chargeableArea, totalCost, unitId , inventoryStatusId(status) , AllotmentPayment!left(kycFormFilled , status , last_updated_at), wingId(wingId , projectId(projectId , projectName), wingName) , inventoryTypeId(inventoryTypeId , type) , leadId(leadType , leadId  , userId(userId , name)),BSP'
    )
    .in('leadId.userId.userId', teamIds);

  if (projectId?.length > 0) {
    query = query.in('projectId', projectId);
  }

  if (
    selectedDate?.[0]?.value !== '0' &&
    selectedDate?.[1]?.value !== '0' &&
    selectedDate?.[1]?.value !== '' &&
    selectedDate?.[0]?.value !== '' &&
    selectedDate?.[0]?.value !== undefined &&
    selectedDate?.[1]?.value !== undefined
  ) {
    query = query
      .lte('created_at', selectedDate?.[1]?.value)
      .gte('created_at', selectedDate?.[0]?.value);
  }

  const { data, error, count } = await query;
  if (data) return { data, count };
  else throw error;
}

async function getUsersByTeams(userIds) {
  return await supabase.from('Users').select('*').in('userId', userIds);
}

async function getCancelledRevenue(ids, projectId, selectedDate) {
  let query = supabase
    .from('AllotmentPayment')
    .select(
      'status,unitCost,leadId(leadId),unitId(unitId,projectId(projectId,projectName)),last_updated_at'
    )
    .in('leadId.userId', ids)
    .eq('status', 'Cancelled');
  if (projectId?.length > 0) {
    query = query.in('unitId.projectId.projectId', projectId);
  }

  if (
    selectedDate?.[0]?.value !== '0' &&
    selectedDate?.[1]?.value !== '0' &&
    selectedDate?.[0]?.value !== '' &&
    selectedDate?.[1]?.value !== '' &&
    selectedDate !== null &&
    selectedDate !== undefined
  ) {
    query = query
      .lte('created_at', Date.parse(new Date(Number(selectedDate?.[1]?.value))))
      .gte(
        'created_at',
        Date.parse(new Date(Number(selectedDate?.[0]?.value)))
      );
  }

  const { data, error } = await query;
  if (data) return { data };
  else throw error;
}

async function getCancellationAndRefund(id, isToken, projectId, selectedDate) {
  if (isToken) {
    const { data, error, count } = await supabase
      .from('EventTokenLeadRelations')
      .select('*,leadId(*)')
      .in('leadId.userId', id);
    if (data) return { data, count };
    else throw error;
  } else {
    let query = supabase
      .from('AllotmentPayment')
      .select('*,leadId(*,personId(*)),unitId(*,projectId(*))')
      .in('leadId.userId', id);

    if (projectId !== null) {
      query = query.eq('unitId.projectId.projectId', projectId);
    }

    if (
      selectedDate?.[0]?.value !== '' &&
      selectedDate?.[1]?.value !== '' &&
      selectedDate !== null &&
      selectedDate !== undefined
    ) {
      query = query
        .lte('created_at', Date.parse(new Date(selectedDate?.[1]?.value)))
        .gte('created_at', Date.parse(new Date(selectedDate?.[0]?.value)));
    }

    const { data, error, count } = await query;
    if (data) return { data, count };
    else throw error;
  }
}

async function getAllotmentDateWise(ids, date) {
  const { data, error, count } = await supabase
    .from('AllotmentPayment')
    .select('*,leadId(*,personId(*))')
    .in('leadId.userId', ids)
    .gt('created_at', date);
  if (data) return { data, count };
  else throw error;
}

async function getAllotmentSummaryDateWise(ids, date) {
  const { data, error, count } = await supabase
    .from('AllotmentPayment')
    .select('*,leadId(*,personId(*))')
    .in('leadId.userId', ids)
    .gt('created_at', date);
  if (data) return { data, count };
  else throw error;
}

async function getAllotmentSourceDateWise(ids, date) {
  const { data, error, count } = await supabase
    .from('AllotmentPayment')
    .select('*,leadId(*,personId(*))')
    .in('leadId.userId', ids)
    .gt('created_at', date);
  if (data) return { data, count };
  else throw error;
}

async function getAllotmentPerformanceDateWise(ids, date) {
  const { data, error, count } = await supabase
    .from('AllotmentPayment')
    .select('*,leadId(*,personId(*))')
    .in('leadId.userId', ids)
    .gt('created_at', date);
  if (data) return { data, count };
  else throw error;
}

async function getPaymentStatusByIds(ids, projectId, selectedDate) {
  let query = supabase
    .from('AllotmentPayment')
    .select(
      'allotmentPaymentId,unitCost,paidAmt,paidAmount,bookingAmt,status,kycFormFilled,leadId(leadId,personId(personId) , userId(userId)),unitId(unitId,chargeableArea,projectId(projectId,projectName,projectShortCode),inventoryStatusId(status))'
    )
    .not("status" , 'ilike' , '%Refund%')
    .not("status" , 'ilike' , '%Cancel%')
    .not("status" , 'ilike' , '%cancel%')
    .not("status" , 'ilike' , '%Released%')
    .in('leadId.userId', ids);

  if (projectId?.length > 0) {
    query = query.in('unitId.projectId.projectId', projectId);
  }

  if (
    selectedDate?.[0]?.value !== '0' &&
    selectedDate?.[1]?.value !== '0' &&
    selectedDate?.[0]?.value !== '' &&
    selectedDate?.[1]?.value !== '' &&
    selectedDate !== null &&
    selectedDate !== undefined
  ) {
    query = query
      .lte('created_at', Date.parse(new Date(Number(selectedDate?.[1]?.value))))
      .gte(
        'created_at',
        Date.parse(new Date(Number(selectedDate?.[0]?.value)))
      );
  }

  const { data, error, count } = await query;
  if (data) return { data, count };
  else throw error;
}

async function getLeadConversionByIds(userId, selectedDate, selectedProject) {
  // const selectedProjectIds = selectedProject?.map((ele) => ele?.id)
  
  let query = supabase
    .from('LeadStatus')
    .select('status, leadId(leadId , userId), allotmentPaymentId(unitId(projectId))')
    .not('leadId', 'is', null)
    // .in('allotmentPaymentId.unitId.projectId',selectedProject)
    

  query = query.eq('leadId.userId', userId);

  if (
    selectedDate?.[0]?.value !== '0' &&
    selectedDate?.[1]?.value !== '0' &&
    selectedDate?.[0]?.value !== '' &&
    selectedDate?.[1]?.value !== '' &&
    selectedDate !== null &&
    selectedDate !== undefined
  ) {
    query = query
      .lte('created_at', Date.parse(new Date(Number(selectedDate?.[1]?.value))))
      .gte(
        'created_at',
        Date.parse(new Date(Number(selectedDate?.[0]?.value)))
      );
  }

  const { data, error, count } = await query;
  if (data) return { data, count };
  else throw error;
}

async function getAllotmentByUser(userId, projectId, selectedDate) {
  let query = supabase
    .from('AllotmentPayment')
    .select(
      'created_at ,allotmentPaymentId, status , leadId(userId,personId(name)) , unitId(projectId(projectName , projectId))'
    )
    .eq('leadId.userId', userId)
    .order('last_updated_at', { ascending: false });


  if (projectId?.length > 0) {
    query = query.in('unitId.projectId.projectId', projectId);
  }

  if (
    selectedDate?.[0]?.value !== '0' &&
    selectedDate?.[1]?.value !== '0' &&
    selectedDate?.[0]?.value !== '' &&
    selectedDate?.[1]?.value !== '' &&
    selectedDate !== null &&
    selectedDate !== undefined
  ) {
    query = query
      .lte('created_at', Date.parse(new Date(Number(selectedDate?.[1]?.value))))
      .gte(
        'created_at',
        Date.parse(new Date(Number(selectedDate?.[0]?.value)))
      );
  }

  const { data, error, count } = await query;
  if (data) return { data, count };
  else throw error;
}


async function getEventTokenByIds(ids, eventId, selectedDate , launchId) {
  let query = supabase
    .from('EventTokenLeadRelations')
    .select(
      'status,eventId,eventTokenId(eventTokenId,tokenId(tokenId,name,isPreselect,isPriorityPass)),leadId(leadId,userId,personId(personId)) , AllotmentPayment!left(leadId)'
    )
    .in('status' , ['alloted' , 'active' , 'adjusted'])
    .in('leadId.userId', ids)
   
    if(eventId !== null && eventId !== undefined && eventId !== "") {
      query = query.eq('eventId', eventId);
    }
    if(launchId !== null && launchId !== undefined && launchId !== "") {
      query = query.eq('launchId', launchId);
    }

  if (
    selectedDate?.[0]?.value !== '0' &&
    selectedDate?.[1]?.value !== '0' &&
    selectedDate?.[0]?.value !== '' &&
    selectedDate?.[1]?.value !== '' &&
    selectedDate !== null &&
    selectedDate !== undefined
  ) {
    query = query
      .lte('created_at', Date.parse(new Date(Number(selectedDate?.[1]?.value))))
      .gte(
        'created_at',
        Date.parse(new Date(Number(selectedDate?.[0]?.value)))
      );
  }

  const { data, error, count } = await query;
  if (data) return { data, count };
  else throw error;
}

async function getUsersByIds(ids) {
  const { data, error, count } = await supabase
    .from('Users')
    .select('*')
    .in('userId', ids);
  if (data) return { data, count };
  else throw error;
}

async function getAllEvents() {
  const { data, error, count } = await supabase
    .from('Events')
    .select('*')
    .eq('isPublished', true);
  if (data) return { data, count };
  else throw error;
}

async function getLeadsDataByIds(id, type) {
  var query;
  query = supabase.rpc('leadsfilter', {}, { count: 'exact' }).in('salesid', id);

  if (type === 'Unclaimed') {
    query = query.in('leadstatus', [
      'Claimed',
      'Site Visit Scheduled',
      'Site Visit Pending',
      type,
    ]);
  } else if (type === 'Site Visit') {
    query = query.in('leadstatus', ['Site Visit Done']);
  } else if (type === 'Token') {
    query = query.in('leadstatus', [
      'Token Payment Pending',
      'Token Partial Payment Done',
      'Token Payment Complete',
      'Checkpoint One Cleared',
      'Checkpoint Two Cleared',
      'Token Refund Requested',
      'Token Refunded',
      'Token Refund Request Rejected',
      'Token Payment Not Done',
    ]);
  } else if (type === 'Allotment') {
    query = query.in('leadstatus', [
      'Allotment Done',
      'Unit On Hold',
      'Allotment Partial Payment Done',
      'Allotment Payment Pending',
      'Allotment Payment Complete',
      'PreSelect Confirmation Pending',
      'PreSelect Price Confirmation Pending',
      'PreSelect Unit On Hold',
      'PreSelect Payment Pending',
      'Preselect not confirmed',
      'PreSelect Partial Payment Done',
      'Preselect payment not done',
      'Unit On Hold',
      'Change Unit Requested',
      'Change Unit Confirmation Pending',
      'Change Unit Confirmation Rejected',
      'Change Unit Confirmed',
      'Change Unit Rejected',
      'Cancellation Confirmation Pending',
      'Cancel Unit Rejected',
      'Cancel Unit Confirmation Rejected',
      'Cancellation Done',
      'Cancellation Pending',
      'Cancellation Not Done',
      'Payment Pending',
      'Unit Change Requested',
      'Allotment Refunded',
    ]);
  }

  const { data, error, count } = await query;
  if (data) return { data, count };
  else throw error;
}

async function getLeadsDataFilterByIds(id, type) {
  var query;
  query = supabase.rpc('leadsfilter', {}, { count: 'exact' }).eq('salesid', id);

  if (type === 'Unclaimed') {
    query = query.in('leadstatus', [
      'Claimed',
      'Site Visit Scheduled',
      'Site Visit Pending',
      type,
    ]);
  } else if (type === 'Site Visit') {
    query = query.in('leadstatus', ['Site Visit Done']);
  } else if (type === 'Token') {
    query = query.in('leadstatus', [
      'Token Payment Pending',
      'Token Partial Payment Done',
      'Token Payment Complete',
      'Checkpoint One Cleared',
      'Checkpoint Two Cleared',
      'Token Refund Requested',
      'Token Refunded',
      'Token Refund Request Rejected',
      'Token Payment Not Done',
    ]);
  } else if (type === 'Allotment' || type === 'Unit Cancellations') {
    query = query.in('leadstatus', [
      'Allotment Done',
      'Unit On Hold',
      'Allotment Partial Payment Done',
      'Allotment Payment Pending',
      'Allotment Payment Complete',
      'PreSelect Confirmation Pending',
      'PreSelect Price Confirmation Pending',
      'PreSelect Unit On Hold',
      'PreSelect Payment Pending',
      'Preselect not confirmed',
      'PreSelect Partial Payment Done',
      'Preselect payment not done',
      'Unit On Hold',
      'Change Unit Requested',
      'Change Unit Confirmation Pending',
      'Change Unit Confirmation Rejected',
      'Change Unit Confirmed',
      'Change Unit Rejected',
      'Cancellation Confirmation Pending',
      'Cancel Unit Rejected',
      'Cancel Unit Confirmation Rejected',
      'Cancellation Done',
      'Cancellation Pending',
      'Cancellation Not Done',
      'Payment Pending',
      'Unit Change Requested',
      'Allotment Refunded',
    ]);
  }

  const { data, error, count } = await query;
  if (data) return { data, count };
  else throw error;
}

async function getAllotment(
  projectId,
  startDate,
  endDate,
  salesId,
  individualUserId
) {
  let teamIds = JSON.parse(localStorage.getItem('teamIds'));
  // const state = { startDate: 1701628200000, endDate: 1701369000000 };
  //   const { data, error } = await supabase.from("CancelUnitRequests").select("*");
  // const limit = 10;
  // const fromCount = page * limit;
  // const toCount = page * limit + (limit - 1);
  let query = supabase
    .from('CancelUnitRequests')
    .select(
      '*,leadId(leadDisplayId,leadType,personId(name), userId(userId, name)),allotmentPaymentId(AllotmentTransactions(*),allotmentPaymentId,paidAmount, unitCost,status,paymentId(eventId(title)),unitId(*,inventoryTypeId(*),projectId(projectId, projectName), wingId(wingName)))'
    );

  if (
    startDate !== '' &&
    endDate !== '' &&
    startDate !== null &&
    endDate !== null &&
    startDate &&
    endDate &&
    (startDate !== '0' || endDate !== '0')
  ) {
    if (startDate === '0') {
      query = query.lte('created_at', endDate);
    } else if (endDate === '0') {
      query = query.gte('created_at', startDate);
    } else if (startDate !== '0' && endDate !== '0') {
      query = query.gte('created_at', startDate).lte('created_at', endDate);
    }
  }

  if (salesId && salesId !== 'All') {
    query = query.eq('leadId.userId.userId', salesId);
  } else {
    query = query.in(
      'leadId.userId.userId',
      individualUserId !== null ? individualUserId : teamIds
    );
  }

  if (
    projectId &&
    projectId?.length > 0 &&
    projectId[0] !== undefined &&
    projectId[0] !== 'null' &&
    projectId[0] !== 'All'
  ) {
    query = query.in(
      'allotmentPaymentId.unitId.projectId.projectId',
      projectId
    );
  }

  // if (projectId?.length > 0) {
  //   query = query.in('allotmentPaymentId.unitId.projectId.projectId', [projectId]);
  // }

  const { data, error } = await query;
  if (data) {
    return data;
  } else throw error;
}

async function getToken(
  startDate,
  endDate,
  salesId,
  eventId,
  individualUserId
) {
  //   const { data, error } = await supabase.from("CancelUnitRequests").select("*");
  let teamIds = JSON.parse(localStorage.getItem('teamIds'));
  let query = supabase
    .from('EventTokenLeadRelations')
    .select(
      '*,leadId(leadDisplayId,personId(name), userId(userId, name)),eventId(eventId,title),eventTokenId(*,TokenTransactions(*),tokenId(*))'
    )
    .ilike('status', '%Refund%');
  if (
    startDate !== '' &&
    endDate !== '' &&
    startDate !== null &&
    endDate !== null &&
    startDate &&
    endDate &&
    (startDate !== '0' || endDate !== '0')
  ) {
    if (startDate === '0') {
      query = query.lte('created_at', endDate);
    } else if (endDate === '0') {
      query = query.gte('created_at', startDate);
    } else if (startDate !== '0' && endDate !== '0') {
      query = query.gte('created_at', startDate).lte('created_at', endDate);
    }
  }

  if (salesId && salesId !== 'All') {
    query = query.eq('leadId.userId.userId', salesId);
  } else {
    query = query.in(
      'leadId.userId.userId',
      individualUserId !== null ? individualUserId : teamIds
    );
  }

  if (eventId && eventId !== 'All') {
    query = query.eq('eventId.eventId', eventId);
  }

  const { data, error } = await query;
  if (data) return data;
  else throw error;
}

async function getSelectedProjectByIds(ids) {
  const { data, error, count } = await supabase
    .from('SustenanceSalesRelations')
    .select('*')
    .in('userId', ids);
  if (data) return { data, count };
  else throw error;
}
async function getSelectedProjectsForDashboard(ids) {
  
  const { data, error, count } = await supabase
    .from('AllotmentPayment')
    .select('*, leadId(userId), unitId(projectId)')
    .in('leadId.userId', ids)
  if (data) return { data, count };
  else throw error;
}
async function getSiteVisits(ids) {
  const { data, error } = await supabase
    .from('SiteVisits')
    .select('leadId(userId), projectId(projectId , projectName)')
    .in('leadId.userId', ids);
  if (data) return data;
  else throw error;
}
 async function individualSiteVisits(userId) {
  console.log("inside individual");
  
   const { data, error } = await supabase
     .from("SiteVisits")
     .select("userId, leadId(userId), projectId(projectId , projectName)")
     .eq("userId", userId);
   if (data) return data;
   else throw error;
 }
async function getEventAssignedToUser(userIds) {
  const { data, error, count } = await supabase
    .from('LaunchSalesRelations')
    .select('launchId(eventId)')
    .in('userId', userIds);
  if (data) return { data, count };
  else throw error;
}

async function getEventBySalesPerson(salesId, userIds) {
  let query = supabase
    .from('LaunchSalesRelations')
    .select('launchId(eventId(eventId,title)), userId');

  if (salesId) {
    query = query.eq('userId', salesId);
  } else {
    query = query.in('userId', userIds);
  }
  const { data, error, count } = await query;
  if (data) return { data, count };
  else throw error;
}

async function FetchIndividualUserFromServer(
  from,
  to,
  userId,
  projectId,
  selectedDate,
  leadId
) {
  let query = supabase
    .from('AllotmentPayment')
    .select(
      'created_at , unitCost , userId , kycFormFilled , status , allotmentPaymentId ,leadId(leadId ,leadDisplayId ,SiteVisits!left(*,projectId(projectId,projectName)), leadType , cpId , personId(name , personId) , userId(name , userId)) , unitId(chargeableArea , unitNo , inventoryStatusId(status) , leadId , totalCost, wingId(wingName , wingId) , projectId(projectId , projectName) , inventoryTypeId(inventoryTypeId , type))'
    )
    .in('leadId.userId', [userId]);

  if (projectId?.length > 0) {
    query = query.in('unitId.projectId.projectId', [projectId]);
  }

  if (leadId) {
    query = query.eq('leadId.personId.personId', leadId);
  }

  if (
    selectedDate?.[0]?.value !== '0' &&
    selectedDate?.[1]?.value !== '0' &&
    selectedDate?.[0]?.value !== 0 &&
    selectedDate?.[1]?.value !== 0 &&
    selectedDate !== null &&
    selectedDate !== undefined
  ) {
    query = query
      .lte('created_at', selectedDate?.[1]?.value)
      .gte('created_at', selectedDate?.[0]?.value);
  }

  const { data, error, count } = await query;
  if (data) return { data, count };
  else throw error;
}

async function getLeadByUser(userId) {
  return await supabase
    .from('Leads')
    .select('userId,leadId,personId(personId,name)')
    .eq('userId', userId);
}

export {
  getAllEvents,
  getEventTokenByIds,
  getPaymentStatusByIds,
  getLeadsDataFilterByIds,
  getUsersByIds,
  getAllotmentPerformanceDateWise,
  getAllotmentSourceDateWise,
  getAllotmentSummaryDateWise,
  getAllotmentDateWise,
  getLeadsDataByIds,
  getCancellationAndRefund,
  getCancelledRevenue,
  getCp,
  cpAnalytics,
  getUnitAnalysis,
  getTopSalesInSustenance,
  getTopSalesInEvent,
  getTokenWiseUnitsSold,
  getTokenDataBySalesTeam,
  getdataforcpdoughnut,
  getTopFosByCp,
  getProjects,
  getAllCounts,
  getTopCpByProject,
  getTopSalesByProject,
  getTopSales,
  getTopProjects,
  getUniqueUnitTypes,
  projectAnalytics,
  getCountsByYearForProject,
  getAllotment,
  getToken,
  FetchTeamWiseUserFromServer,
  getUsersByTeams,
  FetchInventoryFromServer,
  getSelectedProjectByIds,
  getEventAssignedToUser,
  getEventBySalesPerson,
  FetchIndividualUserFromServer,
  getLeadByUser,
  getLeadConversionByIds,
  getAllotmentByUser,
  getSelectedProjectsForDashboard,
  getSiteVisits,
  individualSiteVisits,
};
